/* eslint no-magic-numbers: "off"*/
/* global Foundation*/

import ScrollMagic from 'scrollmagic';

const controller = new ScrollMagic.Controller();

const selectVideo = ( video ) => {

  let videoSource;

  if ( Foundation.MediaQuery.is( 'small only' ) ) {
    videoSource = video.attr( 'data-mobile-url' );
  } else if ( Foundation.MediaQuery.is( 'medium only' ) ) {
    videoSource = video.attr( 'data-tablet-url' );
  } else {
    videoSource = video.attr( 'data-desktop-url' );
  }

  video.find( 'source' ).attr( 'src', videoSource );
  video[0].load();
};

const loadingVideo = () => {

  let $videos = $( '.chr-lazy-load-video' );

  if ( ! $videos.length ) {
    return;
  }

  $videos.each( ( index, video ) => {

    new ScrollMagic.Scene({
      triggerElement: jQuery( video )[0],
      offset:         50,
      triggerHook:    'onEnter', // Move trigger to center of element
      reverse:        false // Only do once
    }).addTo( controller )
      .on( 'enter leave', ( event ) => {

        if ( 'enter' === event.type && ! jQuery( video ).find( 'source' ).attr( 'src' ) ) {
          selectVideo( jQuery( video ) );
        }

      });
  });

};

jQuery( () => {
  loadingVideo();
});
